module.exports = __webpack_public_path__ + "static/media/web.5d93f029.jpg";